import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-feria-escolar',
  templateUrl: './feria-escolar.component.html',
  styleUrls: ['./feria-escolar.component.scss']
})
export class FeriaEscolarComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
